import type { ItemTypeUnit } from "../../../OverviewModal/useItemTypeSettings/types";
import type { ApprovalTarget } from "../../types";
import type { ItemSentenceKeys } from "./types";

export const UNIT_SET_SENTENCE_KEYS: Record<ItemTypeUnit, string> = {
  piece: "unitSetPiece",
  m: "unitSetMeters",
};

export const BULK_APPROVAL_SENTENCE_KEYS: Record<
  ApprovalTarget["kind"],
  Record<"approved" | "unapproved", string>
> = {
  elementType: {
    approved: "bulkApprovedElementTypes",
    unapproved: "bulkUnapprovedElementTypes",
  },
  routeType: {
    approved: "bulkApprovedRouteTypes",
    unapproved: "bulkUnapprovedRouteTypes",
  },
  diagramItemType: {
    approved: "bulkApprovedDiagramItemTypes",
    unapproved: "bulkUnapprovedDiagramItemTypes",
  },
};

// Markers and routes are told the same way; only the nouns differ.
export const MARKER_SENTENCE_KEYS: ItemSentenceKeys = {
  added: "markersAdded",
  addedWithType: "markersAddedWithType",
  removed: "markersRemoved",
  removedTypeGone: "markersRemovedTypeGone",
  moved: "markersMoved",
  movedTypeCreated: "markersMovedTypeCreated",
  movedTypeGone: "markersMovedTypeGone",
  edited: "markerEdited",
};

export const ROUTE_SENTENCE_KEYS: ItemSentenceKeys = {
  added: "routesAdded",
  addedWithType: "routesAddedWithType",
  removed: "routesRemoved",
  removedTypeGone: "routesRemovedTypeGone",
  moved: "routesMoved",
  movedTypeCreated: "routesMovedTypeCreated",
  movedTypeGone: "routesMovedTypeGone",
  edited: "routeEdited",
};
